import axios from "axios";
import { APIS } from "../../../../utils/api-factory";
import { POST_HEADER, TenantHeader } from "../../../../utils/apiHeaders";

export const getEventDataByPageNo = (callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(APIS.GET_EVENT_DATA_BY_PAGE, headerConfig)
    // .get(APIS.GET_EVENT_DATA_BY_PAGE + pageNo + '&noOfEntry=' + noOfEntry, headerConfig)
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};
export const getEventDataCountPageNo = (pageNo, noOfEntry, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(APIS.GET_EVENTS_COUNTS + pageNo + '&noOfEntry=' + noOfEntry, headerConfig)
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};
export const getEventDataByPartnerId = (partnerId, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(APIS.GET_EVENT_DATA_BY_PARTNER_ID + partnerId, headerConfig)
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};
export const getAggregatorPayout = (partnerId, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(APIS.GET_AGGREGATOR_PAYOUT + partnerId, headerConfig)
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};
export const getInCompleteStatsByAggregator = (payload, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.GET_IN_COMPLETE_STATS_BY_AGGREGATOR +
      payload.name +
      `&startDate=${payload.fromDate}&endDate=${payload.toDate}`,
      headerConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};
export const getInCompleteStatsByBranchData = (payload, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.GET_IN_COMPLETE_STATS_BY_BRANCH +
      payload.name +
      `&startDate=${payload.fromDate}&endDate=${payload.toDate}`,
      headerConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};
export const getInCompleteStatsByAggregatorLeads = (
  payload,
  callBack,
  error
) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.GET_IN_COMPLETE_STATS_BY_AGGREGATOR_LEADS +
      payload.name +
      `&startDate=${payload.fromDate}&endDate=${payload.toDate}`,
      headerConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};
export const getInCompleteStatsByBranchDataLeads = (
  payload,
  callBack,
  error
) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.GET_IN_COMPLETE_STATS_BY_BRANCH_LEADS +
      payload.name +
      `&startDate=${payload.fromDate}&endDate=${payload.toDate}`,
      headerConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};
export const getAppliedStatsByBranchData = (payload, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.GET_APPLIED_STATS_BY_BRANCH +
      payload.fromDate +
      `&to=${payload.toDate}&partnerName=${payload.name}`,
      headerConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};
export const getAppliedStatsByAggregator = (payload, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.GET_APPLIED_STATS_BY_AGGREGATOR_SUBMITTED +
      payload.fromDate +
      `&to=${payload.toDate}&partnerName=${payload.name}`,
      headerConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};

export const getAgreegatorListApi = (callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(APIS.GET_AGGREGATOR_NAME, headerConfig)
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};
export const saveOrUpdateAggregatorPayouts = (payload, callBack, error) => {
  console.log(payload, 'payloadpayload')
  const headerConfig = {
    headers: {},
  };
  axios
    .post(APIS.SAVE_OR_UPDATE_AGGREGATOR_PAYOUTS, payload, headerConfig)
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};
// // /// /// // // // /
export const getBranchStatsByPartnerId = (payload, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.GET_BRANCH_STATS_BY_PARTNERID +
      `${payload.partnerId}&startDate=${payload.fromDate}&endDate=${payload.toDate}&type=customer`,
      headerConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};
export const getBranchCommunicateByEventName = (sdate, edate, body, admin, templateIdTosend, headerType, partnerId, eventName, callBack, error) => {
  let data = {
    'sdate': sdate,
    'edate': edate,
    'typeList': 'Message',
    'body': body,
    'empId': admin.emailId,
    'templateId': templateIdTosend,
    'headerType': headerType,
    'partnerId': partnerId,
    'eventName': eventName,
  }
  const headerConfig = {
    headers: {},
  };
  console.log(data)

  // axios
  //   .post(APIS.GET_BRANCH_COMMUNICATE_BY_EVENT_NAME, data, headerConfig)
  //   .then((res) => {
  //     callBack(res.data);
  //   })
  //   .catch((e) => {
  //     error(e.res.data);
  //   });
};

export const getIncompleteStatsByPartnerId = (payload, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.GET_IN_COMPLETE_STATS_BY_PARTNER_ID +
      `${payload.partnerId}&startDate=${payload.fromDate}&endDate=${payload.toDate}`,
      headerConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};
export const getIncompleteDataByPartnerId = (payload, pageNo, noOfEntry, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.GET_IN_COMPLETE_DATA_BY_PARTNER_ID + `${payload.partnerId}&startDate=${payload.fromDate}&endDate=${payload.toDate}&pageNo=${pageNo}&count=${noOfEntry}`,
      headerConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};
export const BulkCommunicateByFormStatus = (sdate, edate, body, admin, templateIdTosend, headerType, partnerId, formStatus, callBack, error) => {
  let data = {
    'sdate': sdate,
    'edate': edate,
    'typeList': ['message'],
    'mailbody': body,
    'empId': admin.emailId,
    'templateId': templateIdTosend,
    'headerType': headerType,
    'partnerId': partnerId,
    'formStatus': formStatus,
  }

  const headerConfig = {
    headers: {},
  };
  console.log(data)
  // axios
  //   .post(APIS.BULK_COMMUNICATION_BY_FORM_STATUS, payload, headerConfig)
  //   .then((res) => {
  //     callBack(res.data);
  //   })
  //   .catch((e) => {
  //     error(e.res.data);
  //   });
};
export const BulkCommunicateByFormStatusMail = (sdate, edate, body, admin, partnerId, formStatus, subject, callBack, error) => {
  let data = {
    'sdate': sdate,
    'edate': edate,
    'typeList': ['mail'],
    'mailbody': body,
    'empId': admin.emailId,
    'partnerId': partnerId,
    'formStatus': formStatus,
    'subject': subject
  }
  const headerConfig = {
    headers: {},
  };
  console.log(data)
  // axios
  //   .post(APIS.BULK_COMMUNICATION_BY_FORM_STATUS, payload, headerConfig)
  //   .then((res) => {
  //     callBack(res.data);
  //   })
  //   .catch((e) => {
  //     error(e.res.data);
  //   });
};
export const BulkCommunicateByFormStatusNotification = (sdate, edate, body, admin, partnerId, formStatus, subject, imgUrl, callBack, error) => {
  let data = {
    'sdate': sdate,
    'edate': edate,
    'typeList': ['notification'],
    'mailbody': body,
    'empId': admin.emailId,
    'partnerId': partnerId,
    'formStatus': formStatus,
    'subject': subject,
    'imgUrl': imgUrl
  }
  const headerConfig = {
    headers: {},
  };
  console.log(data)
  // axios
  //   .post(APIS.BULK_COMMUNICATION_BY_FORM_STATUS, payload, headerConfig)
  //   .then((res) => {
  //     callBack(res.data);
  //   })
  //   .catch((e) => {
  //     error(e.res.data);
  //   });
};
export const BulkCommunicateByLoanStatus = (sdate, edate, body, admin, templateIdTosend, headerType, partnerId, formStatus, callBack, error) => {
  let data = {
    'sdate': sdate,
    'edate': edate,
    'typeList': ['message'],
    'mailbody': body,
    'empId': admin.emailId,
    'templateId': templateIdTosend,
    'headerType': headerType,
    'partnerId': partnerId,
    'loanStatus': formStatus,
  }

  const headerConfig = {
    headers: {},
  };
  console.log(data)
  // axios
  //   .post(APIS.BULK_COMMUNICATION_BY_LOAN_STATUS, payload, headerConfig)
  //   .then((res) => {
  //     callBack(res.data);
  //   })
  //   .catch((e) => {
  //     error(e.res.data);
  //   });
};
export const BulkCommunicateByLoanStatusMail = (sdate, edate, body, admin, partnerId, formStatus, subject, callBack, error) => {
  let data = {
    'sdate': sdate,
    'edate': edate,
    'typeList': ['mail'],
    'mailbody': body,
    'empId': admin.emailId,
    'partnerId': partnerId,
    'loanStatus': formStatus,
    'subject': subject
  }
  const headerConfig = {
    headers: {},
  };
  console.log(data)
  // axios
  //   .post(APIS.BULK_COMMUNICATION_BY_LOAN_STATUS, payload, headerConfig)
  //   .then((res) => {
  //     callBack(res.data);
  //   })
  //   .catch((e) => {
  //     error(e.res.data);
  //   });
};
export const BulkCommunicateByLoanStatusNotification = (sdate, edate, body, admin, partnerId, formStatus, subject, imgUrl, callBack, error) => {
  let data = {
    'sdate': sdate,
    'edate': edate,
    'typeList': ['notification'],
    'mailbody': body,
    'empId': admin.emailId,
    'partnerId': partnerId,
    'loanStatus': formStatus,
    'subject': subject,
    'imgUrl': imgUrl
  }
  const headerConfig = {
    headers: {},
  };
  console.log(data)
  // axios
  //   .post(APIS.BULK_COMMUNICATION_BY_LOAN_STATUS, payload, headerConfig)
  //   .then((res) => {
  //     callBack(res.data);
  //   })
  //   .catch((e) => {
  //     error(e.res.data);
  //   });
};
export const BulkCommunicateByEventStatus = (sdate, edate, body, admin, templateIdTosend, headerType, partnerId, formStatus, callBack, error) => {
  let data = {
    'sdate': sdate,
    'edate': edate,
    'typeList': ['message'],
    'mailbody': body,
    'empId': admin.emailId,
    'templateId': templateIdTosend,
    'headerType': headerType,
    'partnerId': partnerId,
    'eventName': formStatus,
  }

  const headerConfig = {
    headers: {},
  };
  console.log(data)
  // axios
  //   .post(APIS.GET_BRANCH_COMMUNICATE_BY_EVENT_NAME, payload, headerConfig)
  //   .then((res) => {
  //     callBack(res.data);
  //   })
  //   .catch((e) => {
  //     error(e.res.data);
  //   });
};
export const BulkCommunicateByEventStatusMail = (sdate, edate, body, admin, partnerId, formStatus, subject, callBack, error) => {
  let data = {
    'sdate': sdate,
    'edate': edate,
    'typeList': ['mail'],
    'mailbody': body,
    'empId': admin.emailId,
    'partnerId': partnerId,
    'eventName': formStatus,
    'subject': subject
  }
  const headerConfig = {
    headers: {},
  };
  console.log(data)
  // axios
  //   .post(APIS.GET_BRANCH_COMMUNICATE_BY_EVENT_NAME, payload, headerConfig)
  //   .then((res) => {
  //     callBack(res.data);
  //   })
  //   .catch((e) => {
  //     error(e.res.data);
  //   });
};
export const BulkCommunicateByEventStatusNotification = (sdate, edate, body, admin, partnerId, formStatus, subject, imgUrl, callBack, error) => {
  let data = {
    'sdate': sdate,
    'edate': edate,
    'typeList': ['notification'],
    'mailbody': body,
    'empId': admin.emailId,
    'partnerId': partnerId,
    'eventName': formStatus,
    'subject': subject,
    'imgUrl': imgUrl
  }
  const headerConfig = {
    headers: {},
  };
  console.log(data)
  // axios
  //   .post(APIS.GET_BRANCH_COMMUNICATE_BY_EVENT_NAME, payload, headerConfig)
  //   .then((res) => {
  //     callBack(res.data);
  //   })
  //   .catch((e) => {
  //     error(e.res.data);
  //   });
};

export const getAppliedCountStatsByPartnerId = (payload, pageNo, noOfEntry, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.GET_APPLIED_COUNT_STATS_BY_PARTNER_ID +
      `${payload.partnerId}&from=${payload.fromDate}&to=${payload.toDate}&pageNo=${pageNo}&noOfEntry=${noOfEntry}`,
      headerConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};
export const getAppliedDataByPartnerId = (payload, pageNo, noOfEntry, loanStatus, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(APIS.GET_APPLIED_DATA_BY_PARTNER_ID + `${payload.partnerId}&from=${payload.fromDate}&to=${payload.toDate}&pageNo=${pageNo}&count=${noOfEntry}&loanStatus=${loanStatus}`,
      headerConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res);
    });
};

export const getAppliedDataByPartnerIdAndLoanStatus = (
  payload,
  page, count,
  callBack,
  error
) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.GET_APPLIED_DATA_BY_PARTNER_ID_LOAN_STATUS +
      `${payload.partnerId}&from=${payload.fromDate}&to=${payload.toDate}&loanStatus=${payload.loanStatus}&pageNo=${page}&count=${count}`,
      headerConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};
export const getDisbursedCountStatsByPartnerId = (payload, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.GET_DISBURSED_COUNT_STATS_BY_PARTNER_ID +
      `${payload.partnerId}&from=${payload.fromDate}&to=${payload.toDate}`,
      headerConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};

// dashboard

export const getDisbursedStats = (payload, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.GET_DISBURSMENT_STATS +
      `${payload.partnerId}&startDate=${payload.fromDate}&endDate=${payload.toDate}`,
      headerConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};
export const getDisbursedStatsOverall = (payload, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.GET_DISBURSE_OVERALL_COUNT +
      `${payload.fromDate}&endDate=${payload.toDate}`,
      headerConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};
export const getCountByStatusByPartnerId = (payload, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.GET_COUNT_BY_STATUS_BY_PARTNER_ID +
      `${payload.partnerId}&startDate=${payload.fromDate}&endDate=${payload.toDate}`,
      headerConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};
export const getRejectReasonCount = (payload, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.GET_REJECT_REASON_COUNT +
      `${payload.partnerId}&startDate=${payload.fromDate}&endDate=${payload.toDate}`,
      headerConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};
export const getTotalLeadsRecieved = (payload, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.GET_TOTAL_LEADS_RECIEVED +
      `${payload.partnerId}&startDate=${payload.fromDate}&endDate=${payload.toDate}`,
      headerConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};
export const getLeadParticular = (payload, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.GET_LEAD_PARTICULAR +
      `${payload.partnerId}&startDate=${payload.fromDate}&endDate=${payload.toDate}`,
      headerConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};
export const getConverstionDetails = (payload, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.GET_CONVERSTION_DETAILS +
      `${payload.partnerId}&startDate=${payload.fromDate}&endDate=${payload.toDate}`,
      headerConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};
export const getDeviationReport = (payload, pageNo, noOfEntry, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.GET_DEVIATION_REPORT +
      `${payload.fromDate}&endDate=${payload.toDate}&pageNo=${pageNo}&noOfEntry=${noOfEntry}`,
      TenantHeader
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};

export const communicateViaFilterApi = (payload, communicateThrough, status, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(APIS.COMMUNICATE_VIA_FILTER +
      `${payload.fromDate}&endDate=${payload.toDate}&communicateThrough=${communicateThrough}&status=${status}`, headerConfig)
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};
export const statusWiseCommunicationMarketSms = (
  typeList,
  mailbody,
  subject,
  empId,
  imageUrl,
  userIdList,
  templateIdTosend,
  messageHeader,
  payload,
  communicateViaFilter,
  status,
  callBack
) => {
  var data = {
    typeList: typeList,
    mailbody: mailbody,
    subject: subject,
    empId: empId,
    imageUrl: imageUrl,
    userIdList: userIdList,
    templateId: templateIdTosend,
    messageHeader: messageHeader,
    startDate: payload.fromDate,
    endDate: payload.toDate,
    communicationThrough: communicateViaFilter,
    status: status

  }
  console.log(data)
  // fetch(APIS.BULK_COMMUNICATION, {
  //   method: 'POST',
  //   headers: POST_HEADER,
  //   body: JSON.stringify(data)
  // })
  //   .then(res => res.text())
  //   .then(text => {
  //     callBack(text)
  //   })
}
export const getBuisnessFromAgreegatorsApi = (payload, pageNo, noOfEntry, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(APIS.BUISNESS_FROM_AGREEGATORS +
      `${payload.fromDate}&endDate=${payload.toDate}&pageNo=${pageNo}&noOfEntry=${noOfEntry}`, TenantHeader)
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};
export const bulkCommunicateByCsvApiNew = (
  csvFile,
  type,
  requestFrom,
  imgUrl,
  body,
  subject,
  admin,
  templateIdTosend,
  headerType,
  callBack
) => {

  return new Promise((resolve, reject) => {
    let imageFormData = new FormData()
    imageFormData.append('csvfile', csvFile)
    imageFormData.append('type', type)
    imageFormData.append('empId', admin.emailId)
    imageFormData.append('subject', subject)
    imageFormData.append('requestFrom', requestFrom)
    imageFormData.append('body', body)
    imageFormData.append('imageUrl', imgUrl)
    imageFormData.append('templateId', templateIdTosend)
    imageFormData.append('headerType', headerType)

    var xhr = new XMLHttpRequest()
    xhr.open('post', APIS.BULK_COM_BY_CSV, true)
    xhr.onload = function () {
      if (this.status == 200) {
        resolve(this.response)
        callBack(this.response)
      } else {
        reject(this.statusText)
      }
    }
    xhr.send(imageFormData)

  })


}
export const getAutomationLogsNewApi = (payload, pageNo, noOfEntry, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(APIS.GET_AUTOMATION_LOGS_NEW +
      `${payload.fromDate}&endDate=${payload.toDate}&pageNo=${pageNo}&noOfEntry=${noOfEntry}`, headerConfig)
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};
export const getAutomationLogsCountNewApi = (payload, pageNo, noOfEntry, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(APIS.GET_AUTOMATION_LOGS_COUNT +
      `${payload.fromDate}&endDate=${payload.toDate}&pageNo=${pageNo}&noOfEntry=${noOfEntry}`, headerConfig)
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};
export const getOverallparticularLead = (payload, pageNo, noOfEntry, dateType, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(APIS.GET_LEAD_PARTICULAR_OVERALL +
      `${payload.fromDate}&endDate=${payload.toDate}&pageNo=${pageNo}&noOfEntry=${noOfEntry}&dateType=${dateType}`, TenantHeader)
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};
export const getMarketingDashboardCounts = (payload, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.GET_DASHOBARD_COUNTS_MARKETING + `${payload.fromDate}&endDate=${payload.toDate}&partnerId=${payload.partnerId}`, headerConfig)
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};
export const getOveralldashCounts = (payload, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.GET_OVERALL_DASHBOARD_COUNTS + `${payload.fromDate}&endDate=${payload.toDate}`, TenantHeader)
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};
export const leadsCountDashBaordApi = (payload, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.GET_LEADS_COUNT_DASHBOARD_DATA + `${payload.fromDate}&endDate=${payload.toDate}`, TenantHeader)
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};
export const getDeviationCount = (payload, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.GET_DEVIATION_COUNT + `${payload.fromDate}&endDate=${payload.toDate}`, headerConfig)
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};


export const getRejectReasonCountOverall = (payload, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.GET_REJECT_REASON_COUNT_OVERALL +
      `${payload.fromDate}&endDate=${payload.toDate}`,
      TenantHeader
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};
export const getConfigDetailsOfAgreegator = (partnerId, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.GET_AGREEGATOR_CONFIG_BY_AGREEGATOR_ID + partnerId
      ,
      headerConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};

export const getPlaningDetailsOfAgreegator = (partnerId, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.GET_AGREEGATOR_MONTHLY_PLANING_BY_ID + partnerId
      ,
      headerConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};
export const leadParticularDataDateWise = (payload, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.GET_LEAD_PARTICULAR_LEADS_DATA_DATE_WISE + `${payload.fromDate}&endDate=${payload.toDate}`, headerConfig)
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};
export const salaryRangeWiseCountApi = (payload, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.GET_SALARY_WISE_COUNT_DASHBOARD_DATA +
      `${payload.fromDate}&endDate=${payload.toDate}`,
      TenantHeader
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};
export const ageRangeWiseCountApi = (payload, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.GET_AGE_WISE_COUNT_DASHBOARD_DATA +
      `${payload.fromDate}&endDate=${payload.toDate}`,
      TenantHeader
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};
export const emiWiseCountApi = (payload, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.GET_EMI_WISE_COUNT_DASHBOARD_DATA +
      `${payload.fromDate}&endDate=${payload.toDate}`,
      TenantHeader
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};
export const genderWiseCountApi = (payload, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.GET_GENDER_WISE_COUNT_DASHBOARD_DATA +
      `${payload.fromDate}&endDate=${payload.toDate}`,
      TenantHeader
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};
export const loanStatusWiseCountApi = (payload, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.GET_LOAN_STATUS_WISE_COUNT_DASHBOARD_DATA +
      `${payload.fromDate}&endDate=${payload.toDate}`,
      TenantHeader
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};
export const rejectReasonWiseCountApi = (payload, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.GET_REJECT_REASON_WISE_COUNT_DASHBOARD_DATA +
      `${payload.fromDate}&endDate=${payload.toDate}`,
      headerConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};
export const stateWiseCountApi = (payload, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.GET_STATE_WISE_COUNT_DASHBOARD_DATA +
      `${payload.fromDate}&endDate=${payload.toDate}`,
      TenantHeader
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};
export const getAllFormStatusApi = (payload, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.GET_ALL_FORM_STATS +
      `${payload.fromDate}&endDate=${payload.toDate}`,
      TenantHeader
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res.data);
    });
};



export const getLatestEventTimestampAPI = (
  callBack
) => {
  fetch(APIS.GET_LATEST_EVENT_TIMESTAMP)
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch((e) => {
      callBack('')
    })
}

export const getAllPartnerNameByAggregatorNameAPI = (
  callBack
) => {
  fetch(APIS.GET_ALL_PARTNER_NAME_BY_AGGREGATOR_NAME)
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch((e) => {
      callBack('')
    })
}
export const getSingularDasboardDataAPI = (data,
  callBack
) => {
  fetch(APIS.GET_SINGULAR_DASHBOARD_DATA + "pageNo=" + data.pageNo + "&size=" + data.size + "&sDate=" + data.sDate + "&eDate=" + data.eDate + "&applicationId=" + data.applicationId + "&email=" + data.email + "&partnerList=" + data.partnerName + "&companyList=" + data.companyList)
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch((e) => {
      callBack('')
    })
}

export const getSingularDasboardReportAPI = (data,
  callBack
) => {
  fetch(APIS.GET_SINGULAR_DASHBOARD_REPORT + "pageNo=" + data.pageNo + "&size=" + data.size + "&sDate=" + data.sDate + "&eDate=" + data.eDate + "&applicationId=" + data.applicationId + "&email=" + data.email + "&partnerList=" + data.partnerName + "&companyList=" + data.companyList)

    .then(res => res.blob())
    .then(data => {
      var blob = new Blob([data], { type: 'application/vnd.ms-excel' })
      var excelBlob = new Blob(
        [data],
        { type: 'application/vnd.ms-excel' },
        'excel.xls'
      )
      var link = window.URL.createObjectURL(excelBlob)
      window.location = link
      var downloadUrl = URL.createObjectURL(blob)
      var a = document.createElement('a')
      a.href = downloadUrl
      a.download = 'SingularReport.xls'
      document.body.appendChild(a)
      a.click()
      callBack(data)
    })
}

export const SaveSingularLogsCSV = (file, callBack) => {

  const formData = new FormData();
  formData.append('file', file);

  fetch(APIS.SAVE_SINGULAR_LOGS_CSV, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
    },
    body: formData,
  })
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
}

export const getSingularCountsByPartnerEventNameAPI = (
  fromDate, toDate,
  callBack
) => {
  fetch(APIS.GET_SINGULAR_COUNTS_BY_PARTNER_EVENT_NAME + fromDate + "&eDate=" + toDate)
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch((e) => {
      callBack('')
    })
}
export const getCommunityAnalyticsMetricsByDate = (
  start, end,state,city,productType,
  callBack
) => {
  fetch(APIS.GET_COMMUNITY_ANALYTICS_METRICS_BY_DATE + start + "&eDate=" + end + "&state=" + state + "&city=" + city + "&productType=" + productType, TenantHeader)
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch((e) => {
      callBack('')
    })
}
export const getTopPerformingAssetsByDate = (
  start, end,state,city,productType,
  callBack
) => {
  fetch(APIS.GET_TOP_PERFORMING_COMMUNITY_BY_DATE + start + "&eDate=" + end + "&state=" + state + "&city=" + city + "&productType=" + productType,TenantHeader)
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch((e) => {
      callBack('')
    })
}
export const getDealerOverviewListByDatestatus = (
  start, end, status, searchBy, page, size,state,city,productType,
  callBack
) => {
  fetch(APIS.GET_DEALER_OVERVIEW_LIST_BY_DATE_STATUS + start + "&eDate=" + end + "&status=" + status + "&searchBy="
    + searchBy + "&pageNo=" + page + "&noOfEntry=" + size + "&state=" + state + "&city=" + city + "&productType=" + productType,TenantHeader
  )
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch((e) => {
      callBack('')
    })
}
export const getOEMDashboardcompleteDatabyDate = (
  start, end,productType,
  callBack
) => {
  fetch(APIS.GET_OEM_DASHBOARD_COMPLETE_DATA_BY_DATE + start + "&endDate=" + end + "&vehicleType=" + productType
  )
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch((e) => {
      callBack('')
    })
}
export const getOEMDashboardAssignmentDatabyDate = (
  start, end,size,page,productType,
  callBack
) => {
  fetch(APIS.GET_OEM_DASHBOARD_ASSIGNEMENT_DATA_BY_DATE + start + "&endDate=" + end + "&size=" + size + "&page=" + page +  "&vehicleType=" + productType,TenantHeader
  )
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch((e) => {
      callBack('')
    })
}
export const getOemDashboardDetailsByOeMId = (
  id,productType,
  callBack
) => {
  fetch(APIS.GET_OEM_DASHBOARD_DETAILS_BYOEM_ID + id +  "&vehicleType=" + productType,TenantHeader
  )
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch((e) => {
      callBack('')
    })
}
export const getAmuAgentDashboadSuymmary = (
 startDate, endDate,state,city,productType,
  callBack
) => {
  fetch(APIS.GET_AMU_AGENT_DASBOARD_SUMMARY + startDate + "&endDate="+ endDate + "&state=" + state + "&city=" + city + "&productType=" + productType,TenantHeader
  )
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch((e) => {
      callBack('')
    })
}

export const getAmuAgentDashboadOverviewListByData = (
 startDate, endDate,size,page,state,city,productType,
  callBack
) => {
  fetch(APIS.GET_AMU_AGENT_DASBOARD_OVERVIEW_LIST_BY_DATA + startDate + "&endDate="+ endDate+ "&noOfEntry=" + size + "&pageNo=" + page + "&state=" + state + "&city=" + city + "&productType=" + productType,TenantHeader
  )
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch((e) => {
      callBack('')
    })
}
export const getAmuAgentActivityTrendsByDate = (
 startDate, endDate,state,city,productType,
  callBack
) => {
  fetch(APIS.GET_AMU_AGENT_ACTIVITY_TRENDS_BY_DATE + startDate + "&endDate="+ endDate + "&state=" + state + "&city=" + city + "&productType=" + productType,TenantHeader
  )
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch((e) => {
      callBack('')
    })
}
export const getAmuAgentLeadsconversionByDate = (
 startDate, endDate,state,city,productType,
  callBack
) => {
  fetch(APIS.GET_AMU_AGENT_LEADS_CONVERSION_BY_DATE + startDate + "&endDate="+ endDate + "&state=" + state + "&city=" + city + "&productType=" + productType ,TenantHeader
  )
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch((e) => {
      callBack('')
    })
}
export const getAmuAgentLeadsTopPerformerByDate = (
 startDate, endDate,state,city,productType,
  callBack
) => {
  fetch(APIS.GET_AMU_AGENT_TOP_PERFORMERS_BY_DATE + startDate + "&endDate="+ endDate + "&state=" + state + "&city=" + city + "&productType=" + productType,TenantHeader
  )
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch((e) => {
      callBack('')
    })  
}
export const getAssugbedAmuAgentDetailsByData = (
 id,startDate, endDate,page,size,
  callBack
) => {
  fetch(APIS.GET_ASSIGNED_DEALER_FOR_AMU_AGENT_BY_DATA + id + "&startDate=" + startDate + "&endDate="+ endDate + "&pageNo=" + page + "&noOfEntry=" + size ,TenantHeader
  )
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch((e) => {
      callBack('')
    })
}


export const getSalesAgentDashboadSuymmary = (
 startDate, endDate,state,city,productType,
  callBack
) => {
  fetch(APIS.GET_SALES_AGENT_DASBOARD_SUMMARY + startDate + "&endDate="+ endDate + "&state=" + state + "&city=" + city + "&productType=" + productType,TenantHeader
  )
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch((e) => {
      callBack('')
    })
}
export const getSalesAgentDashboadOverviewListByData = (
 startDate, endDate,size,page,state,city,productType,
  callBack
) => {
  fetch(APIS.GET_SALES_AGENT_DASBOARD_OVERVIEW_LIST_BY_DATA + startDate + "&endDate="+ endDate+ "&noOfEntry=" + size + "&pageNo=" + page + "&state=" + state + "&city=" + city + "&productType=" + productType,TenantHeader
  )
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch((e) => {
      callBack('')
    })
}

export const getSalesAgentLeadsconversionByDate = (
 startDate, endDate,state,city,productType,
  callBack
) => {
  fetch(APIS.GET_SALES_AGENT_LEADS_CONVERSION_BY_DATE + startDate + "&endDate="+ endDate + "&state=" + state + "&city=" + city + "&productType=" + productType ,TenantHeader
  )
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch((e) => {
      callBack('')
    })
}

export const getSalesAgentActivityTrendsByDate = (
 startDate, endDate,state,city,productType,
  callBack
) => {
  fetch(APIS.GET_SALES_AGENT_ACTIVITY_TRENDS_BY_DATE + startDate + "&endDate="+ endDate + "&state=" + state + "&city=" + city + "&productType=" + productType,TenantHeader
  )
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch((e) => {
      callBack('')
    })
}


export const getSalesAgentLeadsTopPerformerByDate = (
 startDate, endDate,state,city,productType,
  callBack
) => {
  fetch(APIS.GET_SALES_AGENT_TOP_PERFORMERS_BY_DATE + startDate + "&endDate="+ endDate + "&state=" + state + "&city=" + city + "&productType=" + productType,TenantHeader
  )
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch((e) => {
      callBack('')
    })
}
export const getAllstateListDistrictByType = (
type,
  callBack
) => {
  fetch(APIS.GET_ALL_STATE_DISCTIRCT_LIST_BY_TYPE  + type,TenantHeader
  )
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch((e) => {
      callBack('')
    })
}
export const DownloadOemDashboardList = (
  start,end,
productType,
  callBack
) => {
  fetch(APIS.DOWNLOAD_OEM_DASHBOARD_ASSIGNMENT_LIST + start + "&endDate=" + end +"&vehicleType=" + productType,TenantHeader
  )
    
    .then(res => res.blob())
    .then(data => {
      var blob = new Blob([data], { type: 'application/vnd.ms-excel' })
      var excelBlob = new Blob(
        [data],
        { type: 'application/vnd.ms-excel' },
        'excel.xls'
      )
      var downloadUrl = URL.createObjectURL(blob)
      var a = document.createElement('a')
      a.href = downloadUrl
      a.download = 'OEM_Dealer_Data.xls'
      document.body.appendChild(a)
      a.click()
      callBack(data)
    })
}
export const DownloadAmuAgentDashboardList = (
  start,end,state,city,
productType,
  callBack
) => {
  fetch(APIS.DOWNLOAD_AMU_DASHBOARD_ASSIGNMENT_LIST + start + "&endDate=" + end + "&state=" + state + "&city=" + city + "&productType=" + productType,TenantHeader
  )
    
    .then(res => res.blob())
    .then(data => {
      var blob = new Blob([data], { type: 'application/vnd.ms-excel' })
      var excelBlob = new Blob(
        [data],
        { type: 'application/vnd.ms-excel' },
        'excel.xls'
      )
      var downloadUrl = URL.createObjectURL(blob)
      var a = document.createElement('a')
      a.href = downloadUrl
      a.download = 'AMU_Agent_Data.xls'
      document.body.appendChild(a)
      a.click()
      callBack(data)
    })
}
export const DownloadSalesAgentDashboardList = (
  start,end,state,city,
productType,
  callBack
) => {
  fetch(APIS.DOWNLOAD_SALES_DASHBOARD_ASSIGNMENT_LIST + start + "&endDate=" + end + "&state=" + state + "&city=" + city + "&productType=" + productType,TenantHeader
  )
    
    .then(res => res.blob())
    .then(data => {
      var blob = new Blob([data], { type: 'application/vnd.ms-excel' })
      var excelBlob = new Blob(
        [data],
        { type: 'application/vnd.ms-excel' },
        'excel.xls'
      )
      var downloadUrl = URL.createObjectURL(blob)
      var a = document.createElement('a')
      a.href = downloadUrl
      a.download = 'Sales_Agent_Data.xls'
      document.body.appendChild(a)
      a.click()
      callBack(data)
    })
}
export const DownloadDealerAgentDashboardList = (
  start,end,state,city,
productType,status,
  callBack
) => {
  fetch(APIS.DOWNLOAD_DEALER_DASHBOARD_ASSIGNMENT_LIST + start + "&eDate=" + end + "&state=" + state + "&city=" + city + "&productType=" + productType + "&status=" + status,TenantHeader
   )
    
    .then(res => res.blob())
    .then(data => {
      var blob = new Blob([data], { type: 'application/vnd.ms-excel' })
      var excelBlob = new Blob(
        [data],
        { type: 'application/vnd.ms-excel' },
        'excel.xls'
      )
      var downloadUrl = URL.createObjectURL(blob)
      var a = document.createElement('a')
      a.href = downloadUrl
      a.download = 'Dealer_Data.xls'
      document.body.appendChild(a)
      a.click()
      callBack(data)
    })
}

export const getLoginToBreApprovalFunnelByDate = (
  start,end,state,city,
productType,
  callBack
) => {
  fetch(APIS.GET_LOGIN_TO_BRE_APPROVAL_FUNNEL_BY_DATE + start + "&endDate=" + end + "&state=" + state + "&city=" + city + "&productType=" + productType ,TenantHeader
   )
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch((e) => {
      callBack('')
    })
}
export const getBreApprovalToApprovalFunnelByDate = (
  start,end,state,city,
productType,
  callBack
) => {
  fetch(APIS.GET_BRE_APPROVAL_TO_APPROVAL_FUNNEL_BY_DATE + start + "&endDate=" + end + "&state=" + state + "&city=" + city + "&productType=" + productType ,TenantHeader
   )
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch((e) => {
      callBack('')
    })
}
export const getApprovalToDisbursalFunnelByDate = (
  start,end,state,city,
productType,
  callBack
) => {
  fetch(APIS.GET_APPROVAL_TO_DISBURSAL_FUNNEL_BY_DATE + start + "&endDate=" + end + "&state=" + state + "&city=" + city + "&productType=" + productType ,TenantHeader
   )
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch((e) => {
      callBack('')
    })
}
export const getLoginToDisbursalFunnelByDate = (
  start,end,state,city,
productType,
  callBack
) => {
  fetch(APIS.GET_LOGIN_TO_DISBURSAL_FUNNEL_BY_DATE + start + "&endDate=" + end + "&state=" + state + "&city=" + city + "&productType=" + productType ,TenantHeader
   )
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch((e) => {
      callBack('')
    })
}

export const getDealerAgentMapsInfoByData = (
  start,end,state,city,
productType,type,
  callBack
) => {
  fetch(APIS.GET_DEALER_AGENT_MAPS_INFO_BY_DATA + start + "&endDate=" + end + "&state=" + state + "&city=" + city + "&productType=" + productType + "&communityType=" + type ,TenantHeader
   )
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch((e) => {
      callBack('')
    })
}
export const getStateWiseMapInfoData = (
  start,end,
  callBack
) => {
  fetch(APIS.GET_STATE_WISE_MAP_INFO_DATA + start + "&endDate=" + end ,TenantHeader
   )
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch((e) => {
      callBack('')
    })
}
export const getAllStateListForHubFilter = (
  callBack
) => {
  fetch(APIS.GET_ALL_STATE_LIST_FOR_HUB_FILTER ,TenantHeader
   )
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch((e) => {
      callBack('')
    })
}
export const getHubSummaryDashboardByDate = (
  start,end,state,productType,hubId,
  callBack
) => {
  fetch(APIS.GET_PERFORMANCE_HUB_SUMMARY_DASHBOARD_BY_DATE + start + "&endDate=" + end + "&state=" + state + "&productType=" + productType + "&hubId=" + hubId,TenantHeader
   )
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch((e) => {
      callBack('')
    })
}
export const getHubDashboardByDateList = (
  start,end,state,productType,page,size,hubId,
  callBack
) => {
  fetch(APIS.GET_PERFORMANCE_HUB_DASHBOARD_BY_DATE_LIST + start + "&endDate=" + end + "&state=" + state + "&productType=" + productType + "&pageNo=" + page + "&noOfEntry=" + size + "&hubId=" + hubId ,TenantHeader
   )
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch((e) => {
      callBack('')
    })
}
export const getHubPerformacneFunnelDataByDate = (
  start,end,state,productType,hubId,
  callBack
) => {
  fetch(APIS.GET_PERFORMANCE_FUNNEL_DATA_BY_DATE + start + "&endDate=" + end + "&state=" + state + "&productType=" + productType + "&hubId=" + hubId,TenantHeader
   )
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch((e) => {
      callBack('')
    })
}
export const getHubPerformacneAgentTypeDataByDate = (
  start,end,state,productType,hubId,
  callBack
) => {
  fetch(APIS.GET_PERFORMANCE_AGENTTYPE_DATA_BY_DATE + start + "&endDate=" + end + "&state=" + state + "&productType=" + productType  + "&hubId=" + hubId,TenantHeader
   )
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch((e) => {
      callBack('')
    })
}
export const getHubPerformacneGeographicDistributionDataByDate = (
  start,end,state,productType,hubId,
  callBack
) => {
  fetch(APIS.GET_PERFORMANCE_GEOGRAPHIC_DISTRIBUTION_DATA_BY_DATE + start + "&endDate=" + end + "&state=" + state + "&productType=" + productType + "&hubId=" + hubId,TenantHeader
   )
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch((e) => {
      callBack('')
    })
}
export const getHubPerformacneTopPerformerDataByDate = (
  start,end,state,productType,hubId,
  callBack
) => {
  fetch(APIS.GET_PERFORMANCE_TOP_PERFORMER_DATA_BY_DATE + start + "&endDate=" + end + "&state=" + state + "&productType=" + productType + "&hubId=" + hubId,TenantHeader
   )
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch((e) => {
      callBack('')
    })
}
export const getallHubListForFilterBystate = (
  state,
  callBack
) => {
  fetch(APIS.GET_ALL_HUB_LIST_FOR_FILTER_BY_STATE +state,TenantHeader
   )
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch((e) => {
      callBack('')
    })
}
export const getMarketingDetailsByMetricType = (
  type,startDate,endDate,page,size,state,city,productType,
  callBack
) => {
  fetch(APIS.GET_MARKETING_DETAILS_BY_METRIC_TYPE +type + "&startDate=" + startDate + "&endDate=" + endDate + "&pageNo=" + page + "&noOfEntry=" + size + "&state=" + state + "&city=" + city + "&productType=" + productType,TenantHeader
   )
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch((e) => {
      callBack('')
    })
}